import React, { Component } from 'react';
import firebase from './../Firestore'
//import { Link } from 'react-router-dom';
import FileUploader from "react-firebase-file-uploader";
import CategoriaSelector from './CategoriaSelector'
import NavBar from './NavBar'

//import config from 'react-global-configuration';

class Edit extends Component {

  categoriaID = React.createRef();

  constructor(props) {
    super(props);
    this.unsubscribe = null;
    this.state = {
      key: '',
      nombre: '',
      descripcion: '',
      categoriaID: '',
      imagen: '',
      orden: '',
      precio: '',
      seFracciona: '',
      enStock: '',
      isUploading: false,
      progress: 0,
      imagenURL: '',
      diseno: ''
    };
  }

  async componentDidMount() {
    const ref = firebase.firestore().collection('producto').doc(this.props.match.params.id);
    this.unsubscribe = await ref.get().then((doc) => {
      if (doc.exists) {
        const producto = doc.data();
        this.setState({
          key: doc.id,
          nombre: producto.nombre,
          descripcion: producto.descripcion,
          categoriaID: producto.categoriaID,
          imagen: producto.imagen,
          orden: producto.orden,
          precio: producto.precio,
          seFracciona: producto.seFracciona,
          enStock: producto.enStock,
        });
      } else {
        console.log("No such document!");
      }
    });

    // test gaston22572
    const ref2 = firebase.firestore().collection('categoria').doc(this.state.categoriaID);
    this.unsubscribe = await ref2.get().then((doc) => {
      if (doc.exists) {
        const diseno = doc.data();
        this.setState({
          diseno: diseno.diseno
        });
      } else {
        console.log("No such document!");
      }
    });

    // fin test

  }


  onChange = (e) => {
    const state = this.state
    console.log("cambia", e.target.name, e.target.value)

    if(e.target.name === "precio['grande']" || e.target.name === "precio['mediana']" || e.target.name === "precio['chica']"){
      //{grande: e.target.value}
      //console.log("es precio")
      switch (e.target.name) {
        case "precio['grande']":
          this.setState({precio:{
            grande: Number(e.target.value),
            mediana: Number(document.getElementById('mediana').value),
            chica: Number(document.getElementById('chica').value),
            }});
          break;
        case "precio['mediana']":
          this.setState({precio:{
            grande: Number(document.getElementById('grande').value),
            mediana: Number(e.target.value),
            chica: Number(document.getElementById('chica').value),
            }});
          break;
        case "precio['chica']":
          this.setState({precio:{
            grande: Number(document.getElementById('grande').value),
            mediana: Number(document.getElementById('mediana').value),
            chica: Number(e.target.value),
            }});
          break;
        default:

      }

    } else{
      state[e.target.name] = e.target.value;
      this.setState({producto:state});
      console.log("NO es precio")
    }


  }

  onSubmit = (e) => {
    e.preventDefault();

    //console.log("this.state.orden", this.state.orden)

    const { nombre, descripcion, categoriaID, imagen, orden, precio, seFracciona, enStock } = this.state;

    const updateRef = firebase.firestore().collection('producto').doc(this.state.key);

    let quitarImagen = undefined;
    if (typeof e.target.quitarImagen === 'undefined'){
      quitarImagen = false;
      console.log("aquiii")
    } else {
      quitarImagen = e.target.quitarImagen.checked? '': imagen;
    }

    updateRef.set({
      nombre,
      descripcion,
      categoriaID: this.categoriaID.current.value,
      //imagen: e.target.quitarImagen.checked? '': imagen,
      imagen: quitarImagen,
      orden: Number(this.state.orden) === 0? 100 : this.state.orden,
      precio: typeof this.state.precio === 'object' ? this.state.precio : Number(this.state.precio),
      seFracciona: Boolean(this.state.seFracciona),
      enStock: Boolean(this.state.enStock)
    }).then((docRef) => {
      this.setState({
        key: '',
        nombre: '',
        descripcion: '',
        categoriaID: '',
        imagen: '',
        imagenURL: '',
        orden: '',
        precio: '',
        seFracciona: '',
        enStock: ''
      });
      this.props.history.push("/admin/show/"+this.props.match.params.id)
    })
    .catch((error) => {
      console.error("Error adding document: ", error);
    });
  }


  handleUploadStart = () => this.setState({ isUploading: true, progress: 0 });
  handleProgress = progress => this.setState({ progress });
  handleUploadError = error => {
    this.setState({ isUploading: false });
    console.error(error);
  };
  handleUploadSuccess = filename => {
    this.setState({ imagen: filename, progress: 100, isUploading: false });
    firebase
      .storage()
      .ref("productos")
      .child(filename)
      .getDownloadURL()
      .then(url => this.setState({ imagen: url }));
  };

  render() {
    return (
      <div className="container">
        <NavBar history={this.props.history} />
        <div className="panel panel-default">
          <div className="panel-heading">
            <h3 className="panel-title">
              EDITAR PRODUCTO
            </h3>
          </div>
          <div className="panel-body">
            <form onSubmit={this.onSubmit}>
              <div className="form-group">
                <label htmlFor="nombre">Nombre:</label>
                <input type="text" className="form-control" name="nombre" value={this.state.nombre} onChange={this.onChange} placeholder="Nombre" />
              </div>
              <div className="form-group">
                <label htmlFor="descripcion">Descripcion:</label>
                <textarea rows="4" cols="50" className="form-control" name="descripcion" value={this.state.descripcion} onChange={this.onChange} placeholder="Descripcion"></textarea>
              </div>

              <fieldset disabled>
              <div className="form-group">
                <label htmlFor="categoriaID">Categoria:</label>
                <CategoriaSelector name="categoriaID" categoriaID={this.categoriaID} valorActual={this.state.categoriaID} onChange={this.onChange} />
              </div>
              </fieldset>


              <span className="d-block">Imagen del producto:</span><br/>
              {this.state.isUploading && <p>Progress: {this.state.progress}</p>}
              {this.state.imagen &&
                <div>
                <input type="checkbox" name="quitarImagen" value="quitar" />Quitar imagen<br />
                <img src={this.state.imagen} alt={this.state.nombre} />
                </div>
              }
              <FileUploader
                accept="image/*"
                name="producto"
                randomizeFilename
                storageRef={firebase.storage().ref("productos")}
                onUploadStart={this.handleUploadStart}
                onUploadError={this.handleUploadError}
                onUploadSuccess={this.handleUploadSuccess}
                onProgress={this.handleProgress}
                maxHeight="300"
                maxWidth="400"
              />


            <div className="form-group mt-2">
                <label htmlFor="orden">Orden:</label>
                <input type="number" className="form-control" name="orden" value={this.state.orden} onChange={this.onChange} placeholder="Orden" />
              </div>
              <div className="form-group">


              {this.state.diseno !== "pizza" ? (
                    <div>
                      <label htmlFor="precio">Precio:</label>
                      <input type="number" className="form-control" name="precio" value={this.state.precio} onChange={this.onChange} placeholder="Precio" />
                    </div>
                  ) : (
                    <div>
                    <label htmlFor="grande">Precio grande:</label>
                    <input type="number" id="grande" className="form-control" name="precio['grande']" value={this.state.precio.grande} onChange={this.onChange} placeholder="Precio Grande" />
                    <label htmlFor="mediana">Precio mediana:</label>
                    <input type="number" id="mediana" className="form-control" name="precio['mediana']" value={this.state.precio.mediana} onChange={this.onChange} placeholder="Precio Mediana" />
                    <label htmlFor="chica">Precio chica:</label>
                    <input type="number" id="chica" className="form-control" name="precio['chica']" value={this.state.precio.chica} onChange={this.onChange} placeholder="Precio Chica" />
                    </div>
                  )}


              </div>
              <div className="form-group">

                <select value={this.state.seFracciona} name="seFracciona" onChange={this.onChange} className="custom-select mt-2">
                  <option value={false}>No se Fracciona</option>
                  <option value={true}>Se fracciona</option>
                </select>

              </div>

              <div className="form-group">

                <select value={this.state.enStock} name="enStock" onChange={this.onChange} className="custom-select mt-2">
                  <option value={true}>Hay en stock</option>
                  <option value={false}>No hay en stock</option>
                </select>

              </div>

              <button type="submit" className="btn btn-success">Actualizar</button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default Edit;
